import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import StitchNope from '../../assets/images/others/gif/stitch-nope.gif';

export const NotFound = (props) => {
    const { navParks } = props;
    return (
        <div className="not-found">
            <Navigation navParks={navParks} />
            <Header />
            <section className="quatre-cent-quatre">
                <div className="stitch">
                    <img src={StitchNope} alt="stitch-nope" title="stitch-nope" />
                </div>
                <div className="not">SORRY</div>
                <div className="found">Your page is not found on this server</div>
            </section>
            <Footer />
        </div>
    )
}